
define('ldsh!modules/form_editor/templates/preview_custom_gender_item', ['lodash'], function(_) {return function(obj) {
obj || (obj = {});
var __t, __p = '', __e = _.escape;
with (obj) {
__p +=
((__t = ( text )) == null ? '' : __t) +
'\n';

}
return __p
};});

